export default __webpack_public_path__ + "static/media/chip_500.8c87ef74.svg";